import { HeaderCellProps } from '../../types';
import { Tooltip } from '@mui/material';

const SyncedHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return (
    <Tooltip title="Total completed syncing entities">
      <div>Synced</div>
    </Tooltip>
  );
};

export default SyncedHeaderCell;
